<template>
  <div :class="tabClasses" @click="$emit('click', $event)">
    <TabComplexStyle
      :text="text"
      :size="size"
      :hideButton="hideButton"
      :draggable="draggable && !disabled"
      :disabled="disabled"
      :active="active"
      :actionHandler="actionHandler"
      :icon="icon"
      @drag-start="onDragStart"
      @drag-end="onDragEnd"
    >
      <slot />
    </TabComplexStyle>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../Dropdown.module.scss";
import TabComplexStyle from "@/elements/UI/tabs/TabComplex/TabComplexStyle.vue";

export default defineComponent({
  name: "DropdownComplex",

  components: {
    TabComplexStyle
  },

  emits: {
    click: (event: MouseEvent): boolean => {
      return event instanceof MouseEvent;
    },

    "drag-start": (event: DragEvent): boolean => {
      return event instanceof DragEvent;
    },

    "drag-end": (event: DragEvent): boolean => {
      return event instanceof DragEvent;
    }
  },

  props: {
    text: {
      type: String,
      default: ""
    },

    size: {
      type: String as PropType<Size>,
      default: "S"
    },

    hideButton: {
      type: Boolean,
      default: false
    },

    draggable: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    active: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: 0
    },

    maxSize: {
      type: Number,
      default: 0
    },

    actionHandler: {
      type: Function,
      default: () => ({})
    },

    icon: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    positionClass(): string {
      if (this.maxSize <= 1) {
        return style.single;
      }

      if (this.index === 0) {
        return style.first;
      }

      if (this.index === this.maxSize - 1) {
        return style.last;
      }

      return style.middle;
    },

    tabClasses(): string[] {
      return [
        style.dropdown,
        style[`size${this.size}`],
        this.positionClass,
        this.disabled ? style.disabled : ""
      ];
    }
  },

  methods: {
    onDragStart(event: DragEvent): void {
      if (this.disabled || !this.draggable) {
        event.preventDefault();
        return;
      }

      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
      }

      this.$emit("drag-start", event);
    },

    onDragEnd(event: DragEvent): void {
      this.$emit("drag-end", event);
    }
  }
});
</script>
